import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cloneDeep } from 'lodash';
import { Button, Switch } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { useViewerStore, actions } from '@store/viewerModule/base';
import vmSelector from '@store/viewerModule/selectors';
import {
  SessionDetailsWrapper,
  HeaderWrapper,
  TableHeaderWrapper,
  ToggleSwitch,
  ToggleText,
} from './styled';
import ViewingExperience from './ViewingExperience';
import ContentMetadata from './ContentMetadata';
import useViwerAdvanceData from './useViewerAdvanceData';
import RenderMetadataGroup from './renderMetadataGroup';
import RenderSessionTag from './renderSessionTag';
import { buildLocationMetadata, buildTagGroups } from '../common/utils';
import { SESSION_TAGS_TITLE } from '../../../utils/constants';

function AdvancedSessionDetails() {
  const reduxDispatch = useDispatch();
  const advanceToggleSelector = useSelector(vmSelector).base.advanceToggle;
  const { sessionData, cityData, asnData } = useViwerAdvanceData();
  const [{ rowData, interval }, dispatchContext] = useViewerStore();
  const [showAdvanceTags, setShowAdvanceTags] = useState(cloneDeep(advanceToggleSelector));

  const { isLive } = interval;
  const { SessionId, tags = {}, location } = rowData;
  const {
    cdnTags = [],
    contentTags = [],
    deviceTags = [],
    playerTags = [],
    otherTags = [],
    sessionTags = [],
  } = tags;
  const locationMetadata = buildLocationMetadata(location);
  const tagGroups = buildTagGroups(locationMetadata, cdnTags, deviceTags, playerTags, otherTags);

  const closeBlock = () => {
    dispatchContext(actions.setAdvanced({ showAdvanceDetails: false }));
    dispatchContext(actions.setRowData({ rowData: {} }));
    setShowAdvanceTags(!showAdvanceTags);
  };
  const triggerChange = () => {
    reduxDispatch(actions.setAdvanceToggle({ advanceToggle: !showAdvanceTags }));
    dispatchContext(actions.setAdvanceToggle({ advanceToggle: !showAdvanceTags }));
    setShowAdvanceTags(!showAdvanceTags);
  };

  return (
    <SessionDetailsWrapper>
      <HeaderWrapper>
        <div>Session Details : {SessionId}</div>
        <div>
          <Button type="text" icon={<CloseOutlined />} onClick={() => closeBlock()} />
        </div>
      </HeaderWrapper>

      <ToggleSwitch>
        <Switch checked={showAdvanceTags} onChange={triggerChange} />
        <ToggleText>Advanced Tags</ToggleText>
      </ToggleSwitch>
      {!isLive && (
        <>
          <TableHeaderWrapper>Viewing Experience</TableHeaderWrapper>
          <ViewingExperience
            rowData={rowData}
            sessionAverage={sessionData}
            cityAverage={cityData}
            asnAverage={asnData}
          />
        </>
      )}
      {showAdvanceTags && (
        <>
          <ContentMetadata streamUrl={location.streamUrl} contentMetadata={contentTags} />
          {tagGroups.map((tagGroup) => (
            <RenderMetadataGroup
              metadataGroup={tagGroup.tags}
              title={tagGroup.name}
              key={tagGroup.name}
            />
          ))}
        </>
      )}
      {!showAdvanceTags && (
        <>{<RenderSessionTag sessionTags={sessionTags} title={SESSION_TAGS_TITLE} />}</>
      )}
    </SessionDetailsWrapper>
  );
}

export default AdvancedSessionDetails;
